import React from "react";
import logo from "../assets/images/letter-logo.png";
import stylesGlobal from "../../Navbar/styles/stylesGlobal";
import stylesDesktop from "../../Navbar/styles/stylesDesktop";
import useNavbarLogic from "../../Navbar/hooks/useNavbarLogic"; // ✅ Importa o hook

function NavbarDesktop() {
  const { activeSection, isHovered, setIsHovered, scrollToSection, scrollToContact } = useNavbarLogic();

  return (
    <nav style={stylesGlobal.navbar}>
      <div style={stylesGlobal.logoContainer}>
        <img src={logo} alt="Logo" style={stylesGlobal.logoImage} />
      </div>

      <div style={stylesDesktop.menuContainer}>
        <ul style={stylesDesktop.menu}>
          {["hero", "solutions", "portfolio"].map((section) => (
            <li key={section} style={stylesDesktop.menuItem}>
              <span
                onClick={() => scrollToSection(section)}
                style={{
                  ...stylesDesktop.linkBase,
                  ...(activeSection === section ? stylesGlobal.linkActive : {}),
                }}
              >
                {section === "hero"
                  ? "Início"
                  : section === "solutions"
                  ? "Soluções"
                  : "Portfólio"}
              </span>
            </li>
          ))}
        </ul>
      </div>

      <button
        style={{
          ...stylesGlobal.button,
          ...(isHovered ? stylesGlobal.buttonHover : {}),
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={scrollToContact} // ✅ Agora usa a função do hook
      >
        Entre em contato
      </button>
    </nav>
  );
}

export default NavbarDesktop;
